import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import './style.scss';
import { ACTIONS, getTeam1 } from './../../../../../actions/team-1';
import {detectIconById} from "../../../../../common/enum";
import PlayerSearch from './PlayerSearch';

class MatchSchedule extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            listMatchSchedule: []
        }
        this.onRedirect = this.onRedirect.bind(this);
        this.onChoosePlayer = this.onChoosePlayer.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.response) {
            if (nextProps.status === ACTIONS.GET_INFO_TEAM_1_SUCCESS) {
                this.setState({
                    listMatchSchedule: nextProps.response.schedules || [],
                })

            }
        }
    }

    onRedirect(value, team) {
        const gameDate = moment(value.game_date, 'YYYY/MM/DD').format('YYYYMMDD');
        this.props.history.replace(`/game/${value.id}/${team.id}/${gameDate}`);
    }

    onChoosePlayer(player) {
        this.props.history.push(`/player/${player.id}`);
    }

    render() {
        // const { translate } = this.props;
        return (
            <div className="match-schedule">
                <h3 className="title">1週間の対戦スケジュール</h3>

                <table className="table">
                    <thead>
                        <tr>
                            {
                                this.state.listMatchSchedule && this.state.listMatchSchedule.map((val, i) => {
                                    const monthDay = moment(val.game_date).format('M/D');
                                    return (
                                        <th key={i}>{monthDay}</th>
                                    )
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {
                                this.state.listMatchSchedule && this.state.listMatchSchedule.map((value, index) => {
                                    if(!value.id) {
                                        return <td key={index} style={{fontSize: 12, color: '#0F2533'}}>
                                            試合なし
                                        </td>
                                    }
                                    const playerName = value.pitchers && ((value.home_team.id == this.props.id && value.pitchers.home && value.pitchers.home.player_name) || (value.away_team.id == this.props.id && value.pitchers.away && value.pitchers.away.player_name));
                                    const team = value[`${value.opponent_side}_team`] ? value[`${value.opponent_side}_team`] : {};
                                    return (
                                        <td key={index}>
                                            <div className={'title-schedule'}>
                                                <div style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}} onClick={() => this.onRedirect(value, team)}>
                                                    <img src={detectIconById(team.id)} alt="alt text" />
                                                    <span>{ team.team_name_s }</span>
                                                </div>
                                            </div>
                                            <PlayerSearch
                                                value={playerName}
                                                teamIds={[this.props.id]}
                                                onChoosePlayer={this.onChoosePlayer}
                                            />
                                        </td>
                                    )
                                })
                            }
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

const mapStateToProps = ({ teamReport }) => {
    return {
        response: teamReport.response,
        status: teamReport.status
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getTeam1: (team_id) => {
            dispatch(getTeam1(team_id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(MatchSchedule);
